import BaseService from '../BaseService'

export default class GemeindeService extends BaseService {
  constructor() {
    super('public/gemeinde')
  }

  async search(searchTerm) {
    if (!searchTerm || searchTerm.length < 2) {
      return []
    }
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}?search=${encodeURIComponent(searchTerm)}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
